import {BehaviorSubject} from 'rxjs';

/**
 * IL POSTO DELLA SCHEDINA NEL GUSCIO NOVA.
 *
 * Nel guscio Nova, sul telefono, la schedina si apre dal basso come gli altri
 * pannelli (tasto Schedina della barra). Il pannello e' del guscio, ma la
 * schedina vera (le quote scelte, togli, svuota, gioca) e' della pagina
 * delle quote (SportContainer), che ne tiene lo stato: una seconda copia nel
 * guscio vorrebbe dire due schedine da tenere allineate.
 *
 * Quindi il guscio mette nel pannello un posto vuoto e lo annuncia qui; la
 * pagina delle quote, se e' montata, ci disegna dentro la sua schedina con un
 * portale. Senza pagina delle quote il posto resta vuoto e il pannello dice
 * di andare allo sport. null = nessun posto (guscio di sempre).
 */
const posto = new BehaviorSubject(null);

export const impostaPostoSchedina = (nodo) => posto.next(nodo || null);
export const postoSchedina = () => posto.asObservable();
